export default "__VITE_ASSET__SUhZtREz__"